declare namespace $ {

	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_float_code_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $mol_string_button__value_shm_hitalama_map_widget_float_code_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__no_crdt_shm_hitalama_map_widget_float_code_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['no_crdt'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['no_crdt'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__code_download_blob_shm_hitalama_map_widget_float_code_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['code_download_blob'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_blob'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__code_download_file_name_shm_hitalama_map_widget_float_code_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['code_download_file_name'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_file_name'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__template_dictionary_shm_hitalama_map_widget_float_code_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['template_dictionary'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_dictionary'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__template_selected_shm_hitalama_map_widget_float_code_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['template_selected'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_selected'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__enabled_shm_hitalama_map_widget_float_code_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['enabled'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['enabled'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__run_click_shm_hitalama_map_widget_float_code_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['run_click'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['run_click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_code_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['code_head'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_map_widget_float_code_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['textarea_hint'] >
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $shm_hitalama_textarea__sidebar_showed_shm_hitalama_map_widget_float_code_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_map_widget_float_code_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['code'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__value_click_shm_hitalama_map_widget_float_code_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['widget_value_click'] >
		,
		ReturnType< $shm_hitalama_textarea['value_click'] >
	>
	type $shm_hitalama_textarea__spellcheck_shm_hitalama_map_widget_float_code_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['spellcheck'] >
	>
	type $shm_hitalama_textarea__submit_shm_hitalama_map_widget_float_code_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['run_click'] >
		,
		ReturnType< $shm_hitalama_textarea['submit'] >
	>
	type $shm_hitalama_textarea__style_shm_hitalama_map_widget_float_code_17 = $mol_type_enforce<
		({ 
			'fontSize': ReturnType< $shm_hitalama_map_widget_float_code['font_size_px'] >,
		}) 
		,
		ReturnType< $shm_hitalama_textarea['style'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__widget_shm_hitalama_map_widget_float_code_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['widget'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__map_shm_hitalama_map_widget_float_code_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['map'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__Map_page_shm_hitalama_map_widget_float_code_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['Map_page'] >
	>
	type $shm_hitalama_map_widget_float_code_bench__run_click_shm_hitalama_map_widget_float_code_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['run_click'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench['run_click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_code_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_code_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code['disable_crdt'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_code extends $shm_hitalama_map_widget_float {
		font_size( next?: number ): number
		Font_size_tool( ): $shm_hitalama_map_fontsize
		Widget_title_edit( ): $mol_string_button
		no_crdt( ): boolean
		code_download_blob( ): any
		code_download_file_name( ): string
		template_dictionary( ): Record<string, any>
		template_selected( next?: string ): string
		enabled( next?: boolean ): boolean
		run_click( ): any
		Code_panel( ): $shm_hitalama_map_widget_float_code_panel
		Code_head( ): $mol_view
		textarea_hint( ): string
		code( next?: string ): string
		widget_value_click( id: any, next?: any ): any
		Textarea( ): $shm_hitalama_textarea
		Bench( ): $shm_hitalama_map_widget_float_code_bench
		code_content( ): readonly(any)[]
		disable_crdt( next?: any ): any
		Disable_crdt( ): $mol_button_minor
		disable_crdt_visible( ): readonly(any)[]
		tools_custom( ): readonly(any)[]
		code_head( ): readonly(any)[]
		controls( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=code.view.tree.d.ts.map